import {
  Empty,
  Spin
} from "antd";
import { useSelector } from "react-redux";

import { RootState } from "Redux/store";
import UserInfo from "./UserInfo";

const GoalsManager = () => {
  const { data, loading } = useSelector(
    (state: RootState) => state.fetchGmUserReducer
  );

  if (loading) {
    return <Spin tip="Loading" />;
  }

  if (!data) {
    return <Empty />;
  }

  return (
    <UserInfo />
  );
}

export default GoalsManager;
